import { Field, Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux'
import { Card } from '../UI/Card/Card';
import { SubmitButton } from '../UI/Button/Button'
import { Localize } from '../SelfSignup/Localize';
import PublicVariables from '../../constants/PublicVariables';
import { handleHostOrSubdomainRedirectUrl } from '../../shared/utility';
import { HTTPS_PREFIX, TICKET_SUPPORT_URL } from '../../constants/Constants';
import { VerifySubdomainUrl } from '../../actions/loginAction';

const SubDomainLogin = () => {
    const dispatch = useDispatch();

    const { selectedlanguage } = useSelector((state) => state.language);
    const { verifySubdomainUrlData, verifySubdomainUrlLoading } = useSelector((state) => state.login);

    const [localisedValues, setLocalisedValues] = useState({});

    useEffect(() => {
        if (selectedlanguage?.id) {
            setLocalisedValues(Localize[selectedlanguage.id]); // set the localization value object
        }
    }, [selectedlanguage]);

    const validateSubDomainUrl = (values) => {
        PublicVariables.isVerifyDomainClicked = true; // To avoid redirect INVALID_DOMAIN_URL in the domain availability API insted shown error toast.
        const url = HTTPS_PREFIX + values.subDomainName + process.env.REACT_APP_SUBDOMAINURL // subdomain URL
        dispatch(VerifySubdomainUrl(url));
    }

    useEffect(() => {
        if (verifySubdomainUrlData) {
            const url = verifySubdomainUrlData.customHostMappingUrl || verifySubdomainUrlData.domainUrl;
            handleHostOrSubdomainRedirectUrl(url);
        }
        // eslint-disable-next-line
    }, [verifySubdomainUrlData]);

    const gotoContactSupportPage = () => {
        window.open(TICKET_SUPPORT_URL, "_blank");
    }

    return (
        <>
            <div className="login-section-box custom-scroll-div">
                <div className="login-section-in">
                    <Card>
                        <div className="login-logo-subtext text-center">
                            <h1 className="h3">Enter your domain URL</h1>
                        </div>
                        <Formik
                            initialValues={{
                                subDomainName: ''
                            }}
                            validationSchema={
                                Yup.object({
                                    subDomainName: Yup
                                        .string()
                                        .required(localisedValues?.subdomain_error)
                                        .min(3, localisedValues?.domain_length_msg)
                                        .max(30, localisedValues?.crt_acnt_limit_character_msg)
                                        .matches('^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$', localisedValues?.not_a_valid_subdomain)
                                })
                            }
                            onSubmit={(values) => validateSubDomainUrl(values)}
                        >
                            {formik => (
                                <Form>
                                    <div className="login-with-credential login-with-credential-collapse collapse show">
                                        <div className="form-group">
                                            <label className="form-label" htmlFor="subDomainName">{localisedValues?.blitzz_subdomain_url}</label>
                                            <div className="form-group-in subdomain-form-group">
                                                <Field
                                                    id="subDomainName"
                                                    name="subDomainName"
                                                    type="text"
                                                    className="form-control form-control-grey height-46 focus-font-bold"
                                                    placeholder={localisedValues?.subdomain}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    autoComplete="organization"
                                                    aria-invalid={Boolean(formik.touched.subDomainName && formik.errors.subDomainName) || undefined}
                                                    aria-describedby={formik.touched.subDomainName && formik.errors.subDomainName ? 'subDomainName-error' : undefined}
                                                    aria-required={true}
                                                />
                                                <div className="subdomain-mark">{process.env.REACT_APP_SUBDOMAINURL}</div>
                                            </div>
                                            {formik.touched.subDomainName && formik.errors.subDomainName && <div id="subDomainName-error" role="alert" className="validation-error">{formik.errors.subDomainName}</div>}
                                        </div>
                                        <div className="button-inline text-center padding-top-10 d-flex justify-content-center">
                                            <div className="button">
                                                <SubmitButton className="btn btn-primary font-weight-500" id="" name={localisedValues?.continue} isSubmitting={verifySubdomainUrlLoading} disable={!formik.isValid || (formik.values.subDomainName === "" && formik.errors.subDomainName === undefined)} showLoader={verifySubdomainUrlLoading} ></SubmitButton>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </Card>
                </div>
            </div>
            <div className="login-footer">
                <div className="button">
                    <button
                        type="button"
                        className="btn btn-link text-dec-none height-auto font-weight-600"
                        onClick={gotoContactSupportPage}
                    >
                        {localisedValues?.contact_support}
                    </button>
                </div>
            </div>
        </>
    )
}

export default SubDomainLogin;